import { render, staticRenderFns } from "./HelpCenterDetail.vue?vue&type=template&id=b1675c84&scoped=true&"
import script from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
export * from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterDetail.vue?vue&type=style&index=0&id=b1675c84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1675c84",
  null
  
)

export default component.exports